import DataTable from "@/components/ui/DataTable";
import {
  DeductionItem,
  DeductionItemType,
  DeductionItemTypeLabels,
} from "@/models/deduction-items.model";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PayItemDataTable from "../../PayItemDataTable";
import { TableCell, TableRow } from "@/components/ui/table";
import TextInput from "@/components/form/TextInput";
import NumberInput from "@/components/form/NumberInput";
import { Button } from "@/components/ui/button";
import Dropdown, { Item } from "@/components/form/Dropdown";
import { addHocItem, getDeductionItems } from "@/api/deduction-items";
import { Separator } from "@/components/ui/separator";
import { Dialog } from "@/components/ui/dialog";
import PayItemDialogContainer from "../../dialog/PayItemDialogContainer";
import { Plus } from "lucide-react";
import AddDeductionForm from "./AddDeductionForm";
import { getColumns } from "./columns";

interface Props {
  userId: number;
  month: number;
  year: number;
  payslipId?: number;
}

function DeductionTab({ userId, month, year, payslipId }: Props) {
  const [deductionItems, setDeductionItems] = useState<DeductionItem[]>([]);

  useEffect(() => {
    const fetchDeduction = async () => {
      const res = await getDeductionItems({ userId, month, year });
      setDeductionItems(res);
    };
    fetchDeduction();
  }, [userId, month, year]);

  const updateDeductionItems = (deductionItem: DeductionItem) => {
    setDeductionItems([...deductionItems, deductionItem]);
  };

  const deleteDeductionItem = (id: number) => {
    const updatedItems = deductionItems.filter((item) => item.id !== id);
    setDeductionItems(updatedItems);
  };

  return (
    <div className="flex flex-col gap-3 p-5">
      <div className="flex justify-between">
        <div>
          <div className="text-lg font-bold">Deduction Items (CPF)</div>
          <div className="w-full flex flex-col">
            <div>Includes lateness and unpaid leave.</div>
          </div>
        </div>
        <PayItemDialogContainer
          title="Add Deduction Item"
          description="Includes lateness and unpaid leave."
          form={
            <AddDeductionForm
              userId={userId}
              month={month}
              year={year}
              payslipId={payslipId}
              updateDeductionItems={updateDeductionItems}
            />
          }
        />
      </div>

      <PayItemDataTable
        columns={getColumns(deleteDeductionItem)}
        data={deductionItems}
        header="Current items"
      />
    </div>
  );
}

export default DeductionTab;
